import { Stack } from '@mantine/core';
import { PropsWithChildren } from 'react';

import { Content } from '@/core/components';

interface FilterBoxProps {
  gap?: string;
}

export function FilterBox({ children, gap }: PropsWithChildren<FilterBoxProps>) {
  return (
    <Content type="full">
      <Stack gap={gap ?? 'md'}>{children}</Stack>
    </Content>
  );
}
